"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fraktur = {
    0x20: [0, 0, .25],
    0x21: [.689, .012, .296],
    0x22: [.695, -0.432, .215],
    0x26: [.698, .011, .738],
    0x27: [.695, -0.436, .212],
    0x28: [.737, .186, .389],
    0x29: [.735, .187, .389],
    0x2A: [.692, -0.449, .278],
    0x2B: [.598, .082, .756],
    0x2C: [.107, .191, .278],
    0x2D: [.275, -0.236, .756],
    0x2E: [.102, .015, .278],
    0x2F: [.721, .182, .502],
    0x30: [.492, .013, .502],
    0x31: [.468, 0, .502],
    0x32: [.474, 0, .502],
    0x33: [.473, .182, .502],
    0x34: [.476, .191, .502],
    0x35: [.458, .184, .502],
    0x36: [.7, .013, .502],
    0x37: [.468, .181, .502],
    0x38: [.705, .01, .502],
    0x39: [.469, .182, .502],
    0x3A: [.457, .012, .216],
    0x3B: [.458, .189, .216],
    0x3D: [.368, -0.132, .756],
    0x3F: [.693, .011, .362],
    0x41: [.696, .026, .718],
    0x42: [.691, .027, .884],
    0x43: [.685, .024, .613],
    0x44: [.685, .027, .832],
    0x45: [.685, .024, .663],
    0x46: [.686, .153, .611],
    0x47: [.69, .026, .785],
    0x48: [.666, .133, .72],
    0x49: [.686, .026, .554],
    0x4A: [.686, .139, .552],
    0x4B: [.68, .027, .668, { ic: .014 }],
    0x4C: [.686, .026, .666],
    0x4D: [.692, .027, 1.05],
    0x4E: [.686, .025, .832],
    0x4F: [.729, .027, .827],
    0x50: [.692, .218, .828],
    0x51: [.729, .069, .827],
    0x52: [.686, .026, .828],
    0x53: [.692, .027, .829],
    0x54: [.701, .027, .669],
    0x55: [.697, .027, .646, { ic: .019 }],
    0x56: [.686, .026, .831],
    0x57: [.686, .027, 1.046],
    0x58: [.688, .027, .719],
    0x59: [.686, .218, .833],
    0x5A: [.729, .139, .602],
    0x5B: [.74, .13, .278],
    0x5D: [.738, .131, .278],
    0x5E: [.734, -0.452, .5],
    0x61: [.47, .035, .5],
    0x62: [.685, .031, .513],
    0x63: [.466, .029, .389],
    0x64: [.609, .033, .499],
    0x65: [.467, .03, .401],
    0x66: [.681, .221, .326],
    0x67: [.47, .209, .504],
    0x68: [.688, .205, .521],
    0x69: [.673, .02, .279],
    0x6A: [.672, .208, .281],
    0x6B: [.689, .025, .389],
    0x6C: [.685, .02, .28],
    0x6D: [.475, .026, .767],
    0x6E: [.475, .022, .527],
    0x6F: [.48, .028, .489],
    0x70: [.541, .212, .5],
    0x71: [.479, .219, .489],
    0x72: [.474, .021, .389],
    0x73: [.478, .029, .443],
    0x74: [.64, .02, .333, { ic: .015 }],
    0x75: [.474, .023, .517],
    0x76: [.53, .028, .512],
    0x77: [.532, .028, .774],
    0x78: [.472, .188, .389],
    0x79: [.528, .218, .499],
    0x7A: [.471, .214, .391],
    0xA0: [0, 0, .25],
    0x391: [.716, 0, .75],
    0x392: [.683, 0, .708],
    0x395: [.68, 0, .681],
    0x396: [.683, 0, .611],
    0x397: [.683, 0, .75],
    0x399: [.683, 0, .361],
    0x39A: [.683, 0, .778],
    0x39C: [.683, 0, .917],
    0x39D: [.683, 0, .75],
    0x39F: [.705, .022, .778],
    0x3A1: [.683, 0, .681],
    0x3A2: [.705, .022, .778],
    0x3A4: [.677, 0, .722],
    0x3A7: [.683, 0, .75],
    0x3D2: [.705, 0, .778],
    0x3DC: [.68, 0, .653],
    0x2018: [.708, -0.41, .215],
    0x2019: [.692, -0.395, .215],
    0x2044: [.721, .182, .502],
    0x210C: [.666, .133, .72],
    0x2111: [.686, .026, .554],
    0x211C: [.686, .026, .828],
    0x2128: [.729, .139, .602],
    0x212D: [.685, .024, .613],
    0xE300: [.683, .032, .497],
    0xE301: [.616, .03, .498],
    0xE302: [.68, .215, .333],
    0xE303: [.679, .224, .329],
    0xE304: [.471, .214, .503],
    0xE305: [.686, .02, .333],
    0xE306: [.577, .021, .334, { ic: .013 }],
    0xE307: [.475, .022, .501, { ic: .013 }],
};
//# sourceMappingURL=fraktur.js.map